export enum BaseAssignmentTimeEnum {
  TARGET_TIME = 'targetTime',
  ACTUAL_TIME = 'actualTime',
  BREAK_TARGET = 'break_target',
  BREAK_ACTUAL = 'break_actual',
  ROUNDING = 'rounding',
}
